import { Outlet, createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useAuthStore } from '@/stores/authStore';
import { AdminSidebar } from '@/features/AdminLayout/AdminSidebar';
import { AdminTopBar } from '@/features/AdminLayout/AdminTopBar';

export const Route = createFileRoute('/admin')({
  component: AdminLayout,
});

function AdminLayout() {
  const { user } = useAuthStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (user && user.role !== 'super_admin') {
      navigate({ to: '/dashboard' });
    }
  }, [user, navigate]);

  if (!user || user.role !== 'super_admin') {
    return (
      <div className="flex h-screen items-center justify-center text-muted-foreground">
        Access restricted to KodPrep admins.
      </div>
    );
  }

  return (
    <div className="flex h-screen overflow-hidden bg-muted/20">
      <AdminSidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <AdminTopBar />
        <main
          className="relative flex-1 overflow-y-auto p-6"
          style={{
            background: [
              'radial-gradient(ellipse 72% 60% at 0% 100%, rgba(238, 118, 88, 0.38) 0%, transparent 62%)',
              'radial-gradient(ellipse 72% 60% at 100% 100%, rgba(238, 118, 88, 0.38) 0%, transparent 62%)',
              'white',
            ].join(', '),
          }}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
}
